export const PROFILES_ENDPOINT = {
  PROFILES: '/profiles',
  LOAD_PREFERENCES: '/profiles/preferences',
  LOAD_ABOUT: '/profiles/about'
}
